import ApiInvoker from './apiInvoker';

export default function (module, serverURL = process.env.VUE_APP_SERVER) {
  return (suburl, data, options) => ApiInvoker.request(`${module}/${suburl}`, data, options, serverURL);
}
